import { createReducer } from '@reduxjs/toolkit';
import {
  openQueuePriorityModal,
  closeQueuePriorityModal
} from '../actions/queue-priority-modal.action';

export interface QueuePriorityModalState {
  isOpen: boolean;
}

const initialState: QueuePriorityModalState = { isOpen: false };

const reducer = createReducer(initialState, builder => {
  builder.addCase(openQueuePriorityModal, state => {
    state.isOpen = true;
  });
  builder.addCase(closeQueuePriorityModal, state => {
    state.isOpen = false;
  });
});

/** Falls back to initial state so a store without this slice renders closed instead of throwing. */
export const selectQueuePriorityModal = (state: any): QueuePriorityModalState =>
  state?.queuePriorityModal ?? initialState;

export default reducer;
